import { styled } from '@linaria/react';
import Image from 'next/image';

import { P } from '~components/Typography';
import { hoverable } from '~theme/snippets';

export const ImageContainer = styled(Image)`
	border-radius: 8px;
	overflow: hidden;
	height: 184px;
	width: 100%;
	max-width: 1170px;
	min-width: 0;
	position: absolute;

	@media screen and (max-width: 769px) {
		height: 140px;
	}
`;

export const BannerContainer = styled.div`
	${hoverable};
	max-width: 1170px;
	min-width: 0;
	height: 184px;
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;

	button {
		margin-top: 20px;
	}

	@media screen and (max-width: 769px) {
		height: 140px;
		align-items: flex-start;

		button {
			margin-top: 10px;
		}
	}
`;

export const Title = styled(P)`
	font-size: 32px;
	line-height: 38px;

	@media screen and (max-width: 769px) {
		font-size: 16px;
		line-height: 20px;
		text-align: left;
		max-width: 190px;
	}
`;

export const TopContainer = styled.div`
	z-index: 2;
	display: flex;
	flex-direction: column;
	gap: 8px;

	@media screen and (max-width: 769px) {
		text-align: left;
		margin-left: 12px;
	}
`;

export const ButtonContainer = styled.div`
	@media screen and (max-width: 769px) {
		margin-left: 12px;
	}
`;
